import { render, staticRenderFns } from "./AvailableCategories.vue?vue&type=template&id=44d35bfd&"
import script from "./AvailableCategories.vue?vue&type=script&lang=js&"
export * from "./AvailableCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports